<template>
  <div class="module">
    <div class="title">{{ title }}</div>
    <div class="list">
      <div
        class="item"
        :class="[item.active ? 'active' : '']"
        :key="item.value"
        v-for="item in localList"
        @click="itemClick(item)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { ref, toRefs, watch } from "vue";
export default {
  name: "FilterStatusList",
  props: {
    title: {
      type: String,
      default: "状态",
    },
    defaultIds: {
      type: Array,
      default() {
        return [];
      },
    },
    list: {
      type: Array,
      default() {
        return [
          {
            name: "审批中",
            value: 1,
          },
          {
            name: "已同意",
            value: 2,
          },
          {
            name: "已拒绝",
            value: 3,
          },
          {
            name: "已撤销",
            value: 4,
          },
        ];
      },
    },
  },
  setup(props) {
    const { defaultIds, list } = toRefs(props);

    const activeIds = ref([]);
    const localList = ref([]);

    // 初始化activeId
    watch(
      [defaultIds, list],
      ([defaultIds, list]) => {
        let tempList = [];
        list.map((item) => {
          let temp = {
            name: item.name,
            value: item.value,
          };
          if (defaultIds.some((id) => id == item.value)) {
            temp.active = true;
          }
          tempList.push(temp);
        });
        localList.value = tempList;
      },
      {
        immediate: true,
        deep: true,
      }
    );

    // 列表项切换
    const itemClick = (item) => {
      item.active = !item.active;
      activeIds.value = [];
      localList.value.forEach((item) => {
        if (item.active) {
          activeIds.value.push(item.value);
        }
      });
    };

    const resetEvt = () => {
      localList.value.map((item) => {
        item.active = false;
      });
    };

    return {
      activeIds,
      localList,
      itemClick,
      resetEvt,
    };
  },
};
</script>

<style lang="less" scoped>
.module {
  .title {
    display: flex;
    height: 45px;
    align-items: center;
    color: #999;
    font-size: 15px;
    font-weight: 400;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    max-height: 200px;
    margin: 0 -6px;
    overflow-y: auto;
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 110px;
      height: 36px;
      background: #f2f4f9;
      border-radius: 20px;
      margin: 6px 4px;
      &.active {
        color: #4275fdff;
        background: rgba(66, 117, 253, 0.2);
      }
    }
  }
}
</style>
